var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo } from "react";
import { TextField } from "@folio/stripes/components";
import { useIntl } from "react-intl";
export var AnchorDatesEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange, count = _a.count, disabled = _a.disabled;
    var formatMessage = useIntl().formatMessage;
    var dates = useMemo(function () {
        var arr = __spreadArray([], value.dates, true);
        while (arr.length < count)
            arr.push({ month: 1, day: 15 });
        return arr.slice(0, count);
    }, [value.dates, count]);
    var updateDate = function (idx, patch) {
        var next = __spreadArray([], dates, true);
        next[idx] = __assign(__assign({}, next[idx]), patch);
        onChange({ dates: next });
    };
    return (React.createElement("div", null, dates.map(function (md, idx) { return (React.createElement("div", { key: idx },
        React.createElement(TextField, { type: "number", min: 1, max: 12, value: md.month, onChange: function (e) {
                var num = Math.max(1, Math.min(12, parseInt(e.target.value, 10) || 1));
                updateDate(idx, { month: num });
            }, label: formatMessage({ id: "ui-br-legaldeposits.schedule.anchorDates.month" }, { index: idx + 1 }), disabled: disabled }),
        React.createElement(TextField, { type: "number", min: 1, max: 31, value: md.day, onChange: function (e) {
                var num = Math.max(1, Math.min(31, parseInt(e.target.value, 10) || 1));
                updateDate(idx, { day: num });
            }, label: formatMessage({ id: "ui-br-legaldeposits.schedule.anchorDates.day" }, { index: idx + 1 }), disabled: disabled }))); })));
};
